import { createContext } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import type { BrandPartner } from '@jane/shared/models';

export const BrandPartnerContext = createContext<BrandPartner>(
  undefined as any
);
